export const REFERRAL_BONUS_TAB_QUERY_PARAM = 'tab';

export type ReferralBonusTab = 'in-progress' | 'completed';

export function parseReferralBonusTab(
  tabQueryValue: string | null,
): ReferralBonusTab {
  if (tabQueryValue === 'completed') {
    return 'completed';
  }

  return 'in-progress';
}
